const KEY = "hc_accounts"; // device-local list of accounts signed into on this browser (email/name/role only)
const MAX = 5;

export const listAccounts = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
const write = (list) => { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX))); } catch { /* storage unavailable */ } };

export const rememberAccount = (u) => {
  if (!u?.email || u.is_demo) return;
  write([{ email: u.email, name: u.name, role: u.role }, ...listAccounts().filter((a) => a.email !== u.email)]);
};
export const forgetAccount = (email) => write(listAccounts().filter((a) => a.email !== email));
